import React from 'react';
import { connect } from 'react-redux';

import { Input } from 'reactstrap';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { Alert } from 'reactstrap';

import {
    addToPurchase,
    updatePurchase,
    getDonationTypes,
    changeView
} from '../../../../../../../Redux/Actions/Admin/ManagePurchaseAndRenewalsActions';

import { fetchStates } from '../../../../../../../Redux/Actions/CommonActions';
import '../../ManagePurchaseAndRenewals.scss';

class Donation extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            view: "Donation",
            total: 0,
            id: 0,
            DonationId: 0,
            UserId: "",
            DonationTypeId: null,
            Name: "",
            Address1: this.props.purchaseAndRenewals.userInfo.address1 || "",
            Address2: this.props.purchaseAndRenewals.userInfo.address2 || "",
            City: this.props.purchaseAndRenewals.userInfo.city || "",
            Zip: this.props.purchaseAndRenewals.userInfo.zip || "",
            Phone: this.props.purchaseAndRenewals.userInfo.phone || "",
            Email: this.props.purchaseAndRenewals.userInfo.Email || "",
            stateId:44,
            ActualCost: 0,
            SuggestedCost: 0,
            TransactionId: 0,
            CreateDate: null,
            Donationtype: "",
            State: this.props.purchaseAndRenewals.userInfo.state || "",
            DonationtypeObj: { name: "", id: 0 },
            touched: {
                Name: false,
                donation: false,
                Address1: false,
                City: false,
                Zip: false,
                Phone: false,
                SuggestedCost: false
            },
            alertVisible: false,
            alertColor: "danger",
            alertMessage: ""
        }

    }

    componentDidMount() {
        this.props.fetchStates();
        this.props.getDonationTypes();
        if (this.props.purchaseAndRenewals.editingPurchase) {
            this.setState({
                ...this.props.purchaseAndRenewals.editingPurchase
            })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.purchaseAndRenewals.editingPurchase !== this.props.purchaseAndRenewals.editingPurchase) {
            this.setState({
                ...this.props.purchaseAndRenewals.editingPurchase
            })
        }
    }

    handleChange = ({ target }) => {
        const newState = Object.assign({}, this.state);
        newState[target.name] = (target.name == "SuggestedCost" ? Number(target.value) : target.value);
        this.setState(newState);
    };

    handleSubmit = (event) => {
        event.preventDefault();
        if (this.isModelValid()) {
            event.preventDefault();
            const newState = Object.assign({}, this.state);
            newState.ActualCost = Number(newState.SuggestedCost);
            this.setState(newState);
            if (this.props.purchaseAndRenewals.editingPurchase.Name) {
                this.props.updatePurchase(newState);
            } else {
                this.props.addToPurchase(newState);
            }
            this.props.changeView({ view: "AddItems" })
        } else {
            this.setAllTouchedTrue();
        }
    };

    isModelValid() {
        return this.state.name !== "" &&
            this.state.donation !== "";
    }


    donationTypeChange = (event) => {
        let target = event.target;
        const value = target.value;
        const edited = this.state;
        edited.DonationTypeId = value.id;
        edited.Donationtype = value.name;
        edited.DonationtypeObj = value;
        this.setState({
            ...edited
        });
    }
       
    handleState = (event) => {
        const value = event.target.value;
        if (value !== null) {
            this.setState({
                stateId: value.id,
                State: value
            }); 
        }
    };


    formatPhone = (val) => {
        if (!val) return val;
        var x = val.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        return !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    }

    setAllTouchedTrue() {
        this.setState({
            touched: {
                Name: true,
                donation: true,
                Address1: true,
                City: true,
                Zip: true,
                Phone: true,
                SuggestedCost: true
            }
        })
    }

    handleBlur = (field) => (evt) => {
        this.setState({
            touched: { ...this.state.touched, [field]: true },
        });
    }

    isModelValid() {
        return this.state.Name !== "" &&
            this.state.donation !== "" &&
            this.state.Address1 !== "" &&
            this.state.City !== "" &&
            this.state.Zip !== "" &&
            this.state.SuggestedCost !== 0 &&
            this.state.DonationtypeObj.name !== "" &&
            this.state.Phone !== "";
    }

    render() {
        return (
            <div className="">
                <h1>Donation</h1>
                <form onSubmit={this.handleSubmit}>
                    <div className="row">
                        <div className="col-md-12">
                            <label>Donation Name</label>
                            <Input
                                type="text"
                                name="Name"
                                value={this.state.Name || ""}
                                onChange={this.handleChange}
                                invalid={this.state.touched.Name && this.state.Name === '' ? true : false}
                                onBlur={this.handleBlur('Name')}
                            />
                        </div>
                    </div>    
                    <div className="row">
                        <div className="col-md-6">
                            <label>Donation Type</label>
                            <DropDownList
                                data={this.props.purchaseAndRenewals.donationTypes || []}
                                onChange={this.donationTypeChange}
                                value={this.state.DonationtypeObj}
                                textField="name"
                                dataItemKey="id"
                                allowCustom={true}
                                name="donation"
                                id="Donationtype"
                                className={this.state.touched.donation && this.state.DonationtypeObj.name === '' ? "error" : ""}
                                invalid={this.state.touched.donation && this.state.DonationtypeObj.name === '' ? true : false}
                                onBlur={this.handleBlur('donation')}
                            />
                        </div>
                        <div className="col-md-6">
                            <label>Suggested Cost</label>
                            <div id="suggestedCostDiv">
                                <span className="dollar-prefix sign">$</span>
                                <Input
                                type="number"
                                className="priceInput"
                                step="0.01"
                                min="0"
                                name="SuggestedCost"
                                onChange={this.handleChange}
                                invalid={this.state.touched.SuggestedCost && (this.state.SuggestedCost == 0 || !this.state.SuggestedCost) ? true : false}
                                onBlur={this.handleBlur('SuggestedCost')}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <label>Address1</label>
                            <Input
                                type="text"
                                name="Address1"
                                value={this.state.Address1 || ""}
                                onChange={this.handleChange}
                                invalid={this.state.touched.Address1 && this.state.Address1 === '' ? true : false}
                                onBlur={this.handleBlur('Address1')}
                            />
                        </div>
                        <div className="col-md-6">
                            <label>Address2</label>
                            <Input
                                type="text"
                                name="Address2"
                                value={this.state.Address2 || ""}
                                onChange={this.handleChange}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <label>City</label>
                            <Input
                                type="text"
                                name="City"
                                value={this.state.City || ""}
                                onChange={this.handleChange}
                                invalid={this.state.touched.City && this.state.City === '' ? true : false}
                                onBlur={this.handleBlur('City')}
                            />
                        </div>
                        <div className="col-md-4">
                            <label>State</label>
                            <DropDownList data={this.props.common.states}
                                id="State"
                                name="state"
                                textField="name"
                                dataItemKey="id"
                                onChange={this.handleState}
                                value={this.state.State}
                            />
                        </div>
                        <div className="col-md-4">
                            <label>Zip</label>
                            <Input
                                type="text"
                                name="Zip"
                                value={this.state.Zip || ""}
                                pattern="(\d{5}([\-]\d{4})?)"
                                onChange={this.handleChange}
                                invalid={this.state.touched.Zip && this.state.Zip === '' ? true : false}
                                onBlur={this.handleBlur('Zip')}
                            />
                        </div> 
                    </div>
                    <div className="footer">
                        <div className="form-group">
                            <button type="submit" className="admin-k-button">
                                <i className="fas fa-save"></i>
                                <span>SAVE</span>
                            </button>
                            <button className="admin-k-button" onClick={() => this.props.changeView({ view: "AddItems" })}>
                                <i className="fas fa-times"></i>
                                <span>CANCEL</span>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        )
    }
}



function mapStateToProps(state) {
    return {
        purchaseAndRenewals: state.purchaseAndRenewals,
        common: state.common,
    };
}

export default connect(mapStateToProps, {
    addToPurchase,
    updatePurchase,
    getDonationTypes,
    changeView,
    fetchStates
})(Donation);